import './footer-mobile.scss';
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { PAGE_MOBILE } from "@/lib/constants";
import { ProjectModel } from '@/lib/models/Project';
import { SetAudioMute } from '@/lib/utils/Audio';

interface Props {
  footerType: number;
  footerColor: string | void;
  handlePrevStep: () => void;
  handleNextStep: () => void;
  listProject: ProjectModel[];
  hideBorder?: boolean;
  hideContent?: boolean;
  hideText?: boolean;
}

const FooterMobile = (props: Props) => {
  const { footerType, footerColor, handlePrevStep, handleNextStep, listProject, hideBorder, hideContent, hideText } = props;

  const _renderFooterTitle = () => {
    return (
      <>
        {/* <div className='footer-mobile-border'></div> */}
        <div className={'footer-mobile-container'}>
          <div className={`footer-intro-mobile`}>
            <div className='text-footer-mobile'>
              <div className='footer-button' onClick={handlePrevStep}>
                <div className='contact-us-mobile' >CONTACT US</div>
              </div>
              <div className='footer-mid'></div>
              <div className='footer-button' onClick={handleNextStep}>
                <RightOutlined className="icon-transfer" style={{ mixBlendMode: 'unset' }} />
              </div>
            </div>
          </div>
        </div>
      </>
    )
  };

  const _renderFooterIntro = () => {
    return (
      <>
        <div className='footer-mobile-border'></div>
        <div className={'footer-mobile-container'}>
          <div className={`footer-intro-mobile`}>
            <div className={`text-footer-mobile`}>
              <div className='footer-button' onClick={handlePrevStep}>
                <LeftOutlined className="icon-transfer" />
              </div>
              <p className='letter-scrambler'>
                Experimentation in progress...
              </p>
              <div className='footer-button' onClick={handleNextStep}>
                <RightOutlined className="icon-transfer" />
              </div>
            </div>
          </div>
        </div>
      </>
    )
  };

  const _renderFooterLoading = () => {
    SetAudioMute('.audio-icon', '.video-container video', true);
    return (
      <>
        <div className='footer-mobile-border'></div>
        <div className={'footer-mobile-container'}>
          <div className={`footer-intro-mobile`}>
            <div className={`text-footer-mobile`}>
              <div className='footer-button' onClick={handlePrevStep}>
                <LeftOutlined className="icon-transfer" />
              </div>
              <p className='letter-scrambler'>
                A small lab with big experiments.
              </p>
              <div className='footer-button' onClick={handleNextStep}>
                <RightOutlined className="icon-transfer" />
              </div>
            </div>
          </div>
        </div>
      </>
    )
  };

  const _renderFooterProject = () => {
    return (
      <>
        <div className='footer-mobile-border' style={{ borderColor: 'transparent' }}></div>
        <div className={'footer-mobile-container'}>
          <div className={`footer-intro-mobile`}>
            <div className={`text-footer-mobile`}>
              <div className='footer-button' onClick={handlePrevStep}>
                <LeftOutlined className="icon-transfer" />
              </div>
              <div
                className='footer-mobile-arrows'
                style={{ "--footer-color": footerColor } as React.CSSProperties}
              >
                <span></span>
                <span></span>
                <p className={'text-view-mobile letter-scrambler'}>VIEW THE WORK</p>
              </div>
              <div className='footer-button' onClick={handleNextStep}>
                <RightOutlined className="icon-transfer" />
              </div>
            </div>
          </div>
        </div>
      </>
    )
  };

  const _renderFooterReach = () => {
    return (
      <>
        <div className='footer-mobile-border'></div>
        <div className={'footer-mobile-container'}>
          <div className={`footer-intro-mobile`}>
            <div className={`text-footer-mobile`}>
              <div className='footer-button' onClick={handlePrevStep}>
                <LeftOutlined className="icon-transfer" />
              </div>
              <div className='footer-mid'></div>
              <div className='footer-button' onClick={handleNextStep}>
                <RightOutlined className="icon-transfer" />
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  const _renderFooter = () => {
    switch (footerType) {
      case PAGE_MOBILE.TITLE:
        return _renderFooterTitle();
      case PAGE_MOBILE.LOADING:
        return _renderFooterLoading();
      case PAGE_MOBILE.INTRO:
        return _renderFooterIntro();
      case PAGE_MOBILE.REACH + listProject.length - 1:
        return _renderFooterReach();
      default:
        return _renderFooterProject();
    }
  };

  return (
    <div className={`footer-mobile ${hideBorder ? 'footer-mobile--border-hidden' : ''} ${hideContent ? 'footer-mobile--content-hidden' : ''} ${hideText ? 'footer-mobile--text-hidden' : ''}`}>
      {_renderFooter()}
    </div>
  )

};

export default FooterMobile;
